import { useNavigate, useParams } from 'react-router-dom';
import { useAppContext } from '../../Context';
import { useEffect, useState } from 'react';
import { usePermissions } from '../../services';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card,
  CardContent,
  Chip,
  Grid,
  Typography,
} from '@mui/material';
import { Button } from '../../components/shared/FormElements';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

const OperatorReport: React.FC = () => {
  const { id } = useParams();
  const { apiCall } = useAppContext();
  const navigate = useNavigate();
  const { canView_reports_production } = usePermissions(['view_reports_production']);
  const [dateQuery, setDateQuery] = useState<string>(
    new Date()
      .toLocaleString('es-CO', {
        timeZone: 'America/Bogota', // UTC -5
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
      .split('/')
      .reverse()
      .join('-')
  );
  const [report, setReport] = useState<any>({});

  useEffect(
    () => {
      if (!canView_reports_production) {
        navigate('/');
        return;
      }
      getCurrentReport();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const getCurrentReport = async () => {
    const response = await apiCall('GET', `report/operator/${id}/`, null, '', 'Error al obtener el reporte');
    if (response) {
      setReport(response);
    }
  };

  const getMonthReport = async () => {
    const response = await apiCall(
      'GET',
      `report/operator/${id}/${dateQuery}/`,
      null,
      '',
      'Error al obtener el reporte por fecha'
    );
    if (response) {
      setReport(response);
    }
  };

  const getByDate = async (value: any) => {
    setDateQuery(value);
    getMonthReport();
  };

  return (
    <div className='container-wrap'>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} className='text-left'>
          <h2 className='text-left'>Reporte de Procesos - {report?.operator_name}</h2>
        </Grid>
        <Grid item xs={12} sm={2} className='text-left'>
          <Button variant='contained' color='primary' onClick={() => navigate(-1)}>
            Volver a Operadores
          </Button>
        </Grid>
        <Grid item xs={12} sm={2} className='text-left'>
          <Button variant='contained' color='primary' onClick={() => getCurrentReport()}>
            Informe actual
          </Button>
        </Grid>
        <Grid item xs={12} sm={2} className='text-right'>
          <input
            type='date'
            value={dateQuery}
            onChange={(e) => getByDate(e.target.value)}
            className='form-control date-audit'
          />
        </Grid>
      </Grid>
      {report ? (
        (() => {
          const currentMap = report?.current_processes ?? report?.current_processes_date ?? {};
          const finalizedMap = report?.finalized_processes ?? report?.finalized_processes_date ?? {};
          const processNames = Array.from(
            new Set([...Object.keys(currentMap), ...Object.keys(finalizedMap)])
          ).sort();

          return (
            <Grid container spacing={2}>
              {processNames.map((processName) => {
                const current = currentMap[processName] || { count: 0, ids: [] };
                const finalized = finalizedMap[processName] || { count: 0, ids: [] };

                return (
                  <Grid item xs={12} sm={6} key={processName}>
                    <Card>
                      <CardContent>
                        <Typography variant='h5' component='h2' mb={3}>
                          {processName}
                        </Typography>
                        <Typography color='textSecondary'>
                          Cantidad de prendas en proceso: {current.count}
                        </Typography>
                        {current.ids?.length > 0 && (
                          <Grid mt={5}>
                            <Accordion>
                              <AccordionSummary
                                expandIcon={<FontAwesomeIcon icon={faChevronDown} />}
                                aria-controls='panel1-content'
                                id='panel1-header'
                              >
                                <Typography component='span'>Ordenes</Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                {current.ids?.map((id: number) => (
                                  <a
                                    href={`/orden/${id}`}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                    style={{ textDecoration: 'none' }}
                                  >
                                    <Chip label={id} style={{ margin: 5 }} />
                                  </a>
                                ))}
                              </AccordionDetails>
                            </Accordion>
                          </Grid>
                        )}

                        <Typography color='textSecondary' mt={2}>
                          Cantidad de prendas finalizadas: {finalized.count}
                        </Typography>
                        {finalized.ids?.length > 0 && (
                          <Grid mt={5}>
                            <Accordion>
                              <AccordionSummary
                                expandIcon={<FontAwesomeIcon icon={faChevronDown} />}
                                aria-controls='panel1-content'
                                id='panel1-header'
                              >
                                <Typography component='span'>Ordenes</Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                {finalized.ids?.map((id: number) => (
                                  <a
                                    href={`/orden/${id}`}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                    style={{ textDecoration: 'none' }}
                                  >
                                    <Chip label={id} style={{ margin: 5 }} />
                                  </a>
                                ))}
                              </AccordionDetails>
                            </Accordion>
                          </Grid>
                        )}
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          );
        })()
      ) : null}
    </div>
  );
};

export default OperatorReport;
